<template>
    <div>
        <div v-if="activeBulkPayment && activeBulkPayment.payments" class="pa-5">
            <div v-for="item in activeBulkPayment.payments" :key="item.id">
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.id ? item.id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Description" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.description ? item.description : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Amount" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.amount ? (Math.round(item.amount * 100) / 100).toFixed(2) + "€" : "-" }}
                    </v-col>
                </v-row>
                <v-row v-if="item.reference_no">
                    <v-col class="col-item row-title" cols="3">{{ "Reference number" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.reference_no ? item.reference_no : "-" }}
                    </v-col>
                </v-row>
                <v-row v-if="item.partner_payment_reference">
                    <v-col class="col-item row-title" cols="3">{{ "Partner payment reference" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.partner_payment_reference ? item.partner_payment_reference : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Recipient name" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.recipient_name ? item.recipient_name : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Recipient IBAN" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.recipient_iban ? item.recipient_iban : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.status ? item.status : "-" }}
                    </v-col>
                </v-row>
                <v-divider class="mb-6 mt-6"/>
            </div>
        </div>
        <div v-else class="pa-5">{{ "No data" | t }}</div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import "vue-json-pretty/lib/styles.css";

export default {
    name: "payment-logs-tab",
    computed: {
        ...mapState("bulkPaymentHistory", ["activeBulkPayment"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
